
import { Vue, Component } from 'vue-property-decorator'

@Component({
  name: 'PublicForm',
})
export default class PublicForm extends Vue {
  private created() {
    const targetSlot = this.$slots['default']
    if (targetSlot) {
      const isFormItemChild = targetSlot.every((v) =>
        ['PublicFormItem', 'public-form-item', 'undefined'].includes(String(v.componentOptions?.tag)),
      )
      if (!isFormItemChild) {
        throw new Error(`public-form: 插槽的字内容必须是 <public-form-item> 标签`)
      }
    }
  }
}
